// Konstanten und Rekord-Zugriff von "SiGeKo Run", getrennt von der Komponente:
// eine .tsx-Datei darf fuer Fast Refresh nur Komponenten exportieren.

/** Rekord-Schluessel in localStorage — bleibt auf diesem Geraet. */
export const HI_STORAGE_KEY = 'sigekorun.hi';

// Die Pixel-Schrift "Press Start 2P" wird NICHT von der Komponente geladen
// (index.html bindet nur Inter ein). Steht sie bereit, wird sie genommen,
// sonst greift der Monospace-Rueckfall.
export const PIXEL_FONT = '"Press Start 2P", ui-monospace, "Courier New", monospace';

export function readHighScore(): number {
    try {
        return Number(localStorage.getItem(HI_STORAGE_KEY)) || 0;
    } catch {
        return 0;
    }
}

export function writeHighScore(hi: number): void {
    try {
        localStorage.setItem(HI_STORAGE_KEY, String(hi));
    } catch {
        // Privater Modus o. ae.: der Rekord lebt dann nur bis zum Neuladen.
    }
}
